/* ==========================================================
   "בטח ראיתם אותנו ב:" (סקשן As Seen In Logos) כקרוסלה רציפה.
   ----------------------------------------------------------
   הלוגואים (הבלוקים של הסקשן) מוצגים בשורה אחת שזזה ללא הפסקה,
   ונעצרת כשמעבירים עליה את העכבר. הלוגואים משוכפלים מספיק פעמים
   כדי שהשורה תמלא את המסך ותתחבר לעצמה בלי קפיצה.
   משלים את assets/claude-logo-marquee.css. רץ שוב כשהסקשן נטען
   מחדש בעורך הערכה וכשרוחב החלון משתנה.
   ========================================================== */
(function () {
  'use strict';

  var SPEED = 80; // פיקסלים לשנייה (25 → 50 → 80 לבקשת בעלת החנות)

  function stripEditorAttrs(el) {
    el.removeAttribute('data-shopify-editor-block');
    el.querySelectorAll('[data-shopify-editor-block]').forEach(function (n) {
      n.removeAttribute('data-shopify-editor-block');
    });
  }

  function build(section) {
    var original = section.querySelector('.logo-container[data-clm-original]') ||
      section.querySelector('.logo-container');
    if (!original || !original.children.length) return;

    var marquee = section.querySelector('.clm');
    if (!marquee) {
      marquee = document.createElement('div');
      marquee.className = 'clm';
      var track = document.createElement('div');
      track.className = 'clm-track';
      original.parentNode.insertBefore(marquee, original);
      marquee.appendChild(track);
      track.appendChild(original);
      original.setAttribute('data-clm-original', '');
      original.classList.add('clm-group');
    }

    var trackEl = marquee.querySelector('.clm-track');
    trackEl.querySelectorAll('.clm-clone').forEach(function (c) { c.remove(); });
    original.querySelectorAll('img').forEach(function (img) { img.loading = 'eager'; });

    var groupWidth = original.getBoundingClientRect().width;
    if (!groupWidth) return;

    // מספר זוגי של עותקים, כך שחצי מהם ממלא לפחות את רוחב המסך
    var half = Math.max(1, Math.ceil(marquee.clientWidth / groupWidth));
    for (var i = 1; i < half * 2; i++) {
      var clone = original.cloneNode(true);
      clone.removeAttribute('data-clm-original');
      clone.classList.add('clm-clone');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a').forEach(function (a) { a.tabIndex = -1; });
      stripEditorAttrs(clone);
      trackEl.appendChild(clone);
    }

    trackEl.style.setProperty('--clm-duration', ((groupWidth * half) / SPEED).toFixed(1) + 's');
    marquee.classList.add('clm--ready');
  }

  function run() {
    document.querySelectorAll('.as-seen-in-section').forEach(build);
  }

  function init() {
    run();
    // הלוגואים נטענים בהדרגה – מחשבים שוב כשכולם מוכנים
    window.addEventListener('load', run);
    var timer;
    var lastWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      clearTimeout(timer);
      timer = setTimeout(run, 200);
    });
    document.addEventListener('shopify:section:load', function () { setTimeout(run, 50); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
